// PurchaseReturn Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get purchaseList from backend then update purchaseList in vuex store ***** //
export const updatePurchaseReturnList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('fixed_asset_purchase_return_index', {
      params: params
    })
    commit('updatePurchaseReturnList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch PurchaseReturn from backend ***** //
export const fetchPurchaseReturnInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`fixed_asset_purchase_return_show/${payload}`)
    commit('fetchPurchaseReturnInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch unClosedPurchaseReturnCount from backend ***** //
export const fetchUnClosedPurchaseReturnCount = async ({ commit }) => {
  try {
    const result = await Axios.get(`unclosed_fixed_asset_purchase_return_count`)
    commit('fetchUnClosedPurchaseReturnCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch unClosedPurchaseReturnCount from backend ***** //
export const fetchUnPaidPurchaseReturnCount = async ({ commit }) => {
  try {
    const result = await Axios.get(`unpaid_fixed_asset_purchase_return_count`)
    commit('fetchUnPaidPurchaseReturnCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Close PurchaseReturn from backend ***** //
export const closePurchaseReturn = async (ignored, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.get(`fixed_asset_purchase_return_close/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Closed Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Open PurchaseReturn from backend ***** //
export const openPurchaseReturn = async (ignored, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.get(`fixed_asset_purchase_return_unclose/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Opened Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add PurchaseReturn  ***** //
export const addPurchaseReturn = async (ignored, payload = null) => {
  try {
    await Axios.post('fixed_asset_purchase_return_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Return Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update PurchaseReturn  info ***** //
export const updatePurchaseReturnInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`fixed_asset_purchase_return_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete PurchaseReturn  ***** //
export const deletePurchaseReturn = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`fixed_asset_purchase_return_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}
